<template>
  <div class="page">
    <div class="main">
      <div class="login">注册</div>
      <div class="ph-input">
        <van-field v-model="recordLoginText" type="tel" left-icon="debit-pay" readonly clear-trigger="always" class="ph-t" placeholder="请输入卡号进行绑定" />
      </div>
      <div class="ph-input" style="margin-top:0px;">
        <van-field v-model="userPhone" type="tel" left-icon="phone-circle-o" clear-trigger="always" class="ph-t" clearable placeholder="请输入您自己的电话卡进行绑定" />
      </div>
      <div v-if="userPhone" class="ph-input" style="margin-top:0px;">
        <van-field v-model="smsCode" type="tel" left-icon="description" clear-trigger="always" class="ph-t" clearable placeholder="验证码">
          <template #button>
            <van-button v-if="!countdown" size="small" type="primary" @click="getCode">发送验证码</van-button>
            <van-button v-if="countdown" size="small" type="primary" disabled>{{ count }}S后重新获取</van-button>
          </template>
        </van-field>
      </div>
      <van-button class="bu_tn-a" round block type="info" native-type="submit" @click="onSubmit">验证登录</van-button>
      <div class="tis">温馨提示</div>
       <div class="tis-small">1、手机绑定后，下次可用手机号直接登录查询。</div>
      <div class="tis-small">2、根据工信部规定，进入系统后要依法认证实名信息。</div>
      <div class="tis-small">3、订购完成+实名认证后，即可使用(首次订购套餐系统可能出现1小时左右延迟)</div>
    </div>
    <van-dialog
      v-model="reacheShow"
      title="图形验证码"
      :show-confirm-button="false"
    >
      <div @click="refreshCode">
        <s-identify :identify-code="identifyCode" />
      </div>
      <div class="captcha">
        <input
          v-for="(c, index) in ct"
          :key="index"
          ref="input"
          v-model="ct[index]"
          type="number"
          :style="{borderBottomColor: index <= cIndex ? '#00c777' : ''}"
          :disabled="loading"
          @input="e => {onInput(e.target.value, index)}"
          @keydown.delete="e=>{onKeydown(e.target.value, index)}"
          @focus="onFocus"
        >
      </div>
      <div class="btn-vis">
        <van-button type="primary" class="dialog-btn2" @click="getCode">获取验证码</van-button>
        <van-button type="primary" class="dialog-btn3" @click="closeShow">关闭</van-button>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast } from 'vant'
import SIdentify from '@/components/canvas.vue'
export default {
  components: {
    SIdentify
  },
  data() {
    return {
      userPhone: null,
      smsCode: '',
      iccid: localStorage.getItem('iccid'),
      recordLoginText: localStorage.getItem('recordLoginText'),
      reacheShow: false,
      loading: false,
      identifyCodes: '1234567890',
      ct: ['', '', '', ''],
      identifyCode: '',
      countdown: false,
      count: null,
      timer: null

    }
  },
  computed: {
    ctSize() {
      return this.ct.length
    },
    cIndex() {
      let i = this.ct.findIndex(item => item === '')
      i = (i + this.ctSize) % this.ctSize
      return i
    },
    lastCode() {
      return this.ct[this.ctSize - 1]
    }
  },
  watch: {
    cIndex() {
      this.resetCaret()
    },
    lastCode(val) {
      if (val) {
        this.$refs.input[this.ctSize - 1].blur()
      }
    }
  },
  mounted() {
    document.onkeydown = (e) => {
      if (e.keyCode == 8) { // 这是delete健，当然也可以根据自己的需求更改
        this.deleteKeyup()// 操作方法
      }
    }
  },
  methods: {
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refresh() {
      this.reacheShow = true
      this.refreshCode()
    },
    // 切换验证码
    refreshCode() {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    onInput(val, index) {
      val = val.replace(/\s/g, '')
      if (index === this.ctSize - 1) {
        this.ct[this.ctSize - 1] = val[0] // 最后一个码，只允许输入一个字符。
        this.getCode()
      } else if (val.length > 1) {
        let i = index
        for (i = index; i < this.ctSize && i - index < val.length; i++) {
          this.ct[i] = val[i]
        }
        this.resetCaret()
      }
    },
    // 重置光标位置。
    resetCaret() {
      this.$refs.input[this.ctSize - 1].focus()
    },
    onFocus() {
      // 监听 focus 事件，将光标重定位到“第一个空白符的位置”。
      let index = this.ct.findIndex(item => item === '')
      index = (index + this.ctSize) % this.ctSize
      this.$refs.input[index].focus()
    },
    onKeydown(val, index) {
      if (val === '') {
        // 删除上一个input里的值，并对其focus。
        if (index > 0) {
          this.ct[index - 1] = ''
          this.$refs.input[index - 1].focus()
        }
      }
    },
    deleteKeyup() {
      this.$refs.input[this.ctSize - 1].focus()
    },
    sendCaptcha() {
      // 此时无法操作 input。。
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.$nextTick(() => {
          this.reset()
        })
      }, 3000)
    },
    reset() {
      // 重置。一般是验证码错误时触发。
      this.ct = this.ct.map(item => '')
      this.resetCaret()
    },
    closeShow() {
      this.reacheShow = false
    },
    getCode() {
      this.closeShow()
      // if (!String(this.ct.join(''))) {
      //   Toast.fail('请输入验证码')
      //   return
      // } else if (String(this.ct.join('')) !== this.identifyCode) {
      //   Toast.fail('验证码不正确!')
      //   return
      // }
      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.userPhone))) {
        Toast.fail('请填写正确的手机号')
        return
      }
      wxRequest('/bindPhone/sms/code', { userPhone: this.userPhone }, 'post').then(res => {
        if (res.data.code === '200') {
          this.countDown()
            Toast.success('发送成功')
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    countDown() {
      const TIME_COUNT = 59
      if (!this.timer) {
        this.count = TIME_COUNT
        console.log(this.count)
        this.countdown = false
        this.timer = setInterval(() => {
          if (this.count > 0) {
            this.count--
            this.countdown = true
          } else {
            this.countdown = false
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    onSubmit() {
      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.userPhone))) {
        Toast.fail('请填写正确的手机号')
        return
      }
      wxRequest('bindPhone/phone/new/success', { userPhone: this.userPhone, smsCode: this.smsCode, iccid: localStorage.getItem('iccid') }, 'post').then(res => {
        if (res.data.code === '200') {
          localStorage.setItem('isAutoHome', 1) // 1表示自动跳转到 firstHome
          localStorage.setItem('userPhone', this.userPhone)
          this.$router.replace('/newUser/home')
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    loginSumbit() {
      var params = {
        iccid: this.iccid,
        userPhone: this.userPhone,
        smsCode: this.smsCode
      }
      wxRequest('/bindPhone/phone/new/success', params, 'post').then(res => {
        if (res.data.code === '200') {
          this.$router.replace('/newUser/home')
        } else {
          Toast.fail(res.data.message)
        }
      })
    }
  }
}
</script>
  <style lang="less" scoped>
  .page{
      background: #f7f8fa;
      display: flex;
      flex-direction: column;
      flex: 1;
      height:100%;
      .main{
        flex: 1;
        display: flex;
        align-items: stretch;
        flex-direction: column;
        .login{
            margin: 60px 0px 0px 24px;
            font-size: 28px;
            color: rgb(6, 18, 30);
            font-weight: bold;
        }
        .login-text{
            color: #707070;
            font-size: 16px;
            margin-left:24px;
            margin-top: 14px;
            line-height:20px;
            width:90%;
        }
        .captcha {
            display: flex;
            justify-content: center;
            margin-top: 40px;
        }
        input {
            margin-right: 20px;
            width: 45px;
            text-align: center;
            border: none;
            border-bottom: 1px solid #212121;
            font-size: 24px;
            outline: none;
            background: none;
        }
        input:last-of-type {
            margin-right: 0;
        }
        input:disabled {
            color: #000;
            background-color: #fff;
        }
        .point{
            flex-direction: row;
            margin-top: 37px;
            justify-content: center;
            display: flex;
            font-size: 17px;
            color: #707070;
            margin-bottom: 36px;
            .once{
                color:#0c62ee;
            }
        }

        .ph-input{
            margin: 40px 24px 20px;
            height: 60px;
            border-bottom: 1px solid #e3e2e2;
            flex-direction: row;
            align-items: center;
            flex-grow: 0;
            display: flex;
            .ph-text{
                color: #06121e;
                width: 50px;
                line-height: 50px;
                height: 50px;
                font-size: 17px;
            }
            .ph-t{
                color: #06121e;
                flex: 1;
                line-height: 50px;
                height: 50px;
                font-size: 17px;
                padding: 0;
                background: none;
                ::v-deep .van-field__left-icon{
                  .van-icon{
                      font-size:22px;
                  }
                }
                ::v-deep.van-cell__value{
                    .van-field__control{
                        background: none;
                        padding-left:14px;
                        color: #000 ;
                        // font-weight: bold;
                        &::-webkit-input-placeholder {
                          color: #000 ;
                        }
                    }
                }
            }
        }
        .bu_tn{
            width: 230px;
            height: 50px;
            line-height: 50px;
            background: rgba(52,118,254,.1)!important;
            color: #3476fe;
            border: 0!important;
            border-radius: 94px;
            font-size: 16px;
            align-self: center;
            text-align: center;
        }
        .bu_tn-a{
            width: 230px;
            height: 50px;
            line-height: 50px;
            background: #3476fe!important;
            color: #fff;
            border: 0!important;
            border-radius: 94px;
            font-size: 16px;
            align-self: center;
            text-align: center;
        }
        .tis{
          font-size:18px;
          font-weight: 600;
          margin-top:40px;
          margin-left:24px;
        }
        .tis-small{
          font-size:12px;
          margin-left:24px;
          padding-top:10px;
          width:90%;
          line-height: 22px;
          color:#666;
        }
      }
      .agree{
          display: flex;
          width:300px;
          position:fixed;
          bottom:25px;
          flex-direction: row;
          justify-content: center;
          margin: auto;
          left:0;
          right: 0;
          text-align: center;
          line-height:20px;
          .van-checkbox{
              margin-right: 6px;
              width: 30px;
              ::v-deep .van-icon{
                  width: 1em;
                  height: 1em;
                  line-height: 1;
              }
          }
          span{
              color:#0c62ee;
              display: contents;
          }
      }
  }
  .van-dialog {
  ::v-deep.van-dialog__content {
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    .captcha {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
    input {
        margin-right: 20px;
        width: 45px;
        text-align: center;
        border: none;
        border-bottom: 1px solid #212121;
        font-size: 24px;
        outline: none;
        background: none;
    }
    input:last-of-type {
        margin-right: 0;
    }
    input:disabled {
        color: #000;
        background-color: #fff;
    }
    .point{
        flex-direction: row;
        margin-top: 37px;
        justify-content: center;
        display: flex;
        font-size: 17px;
        color: #707070;
        margin-bottom: 36px;
        .once{
            color:#0c62ee;
        }
    }
  }
  ::v-deep .van-dialog__header {
    font-size: 20px;
    font-weight: 700;
    color: #06121e;
    text-align: center;
    margin-bottom: 10px;
  }
  .dialog-text {
    font-size: 14px;
    color: #06121e;
    margin-top: 8px;
    line-height: 28px;
  }
  .btn-vis {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 25px;
    .dialog-btn2 {
      width: 120px;
      height: 47px;
      color: #3476fe;
      text-align: center;
      background: rgba(52, 118, 254, 0.1) !important;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      line-height: 47px;
    }
    .dialog-btn3 {
      width: 130px;
      height: 47px;
      border-radius: 94px;
      font-size: 16px;
      line-height: 47px;
      border: 0;
      color: #fff;
      background: #3476fe;
      text-align: center;
    }
  }

}
  </style>

